export default __webpack_public_path__ + "static/media/qsv_logo.46c79974.png";